// 后端地址解析：
// - 生产：HTTPS 经 nginx 同源反代 /api /socket.io → 用页面 origin（否则 https 页面连 http:3001 会被混合内容拦截）
// - 本地/局域网开发：vite dev server（:5173）直连后端 :3001
function resolveServerUrl(): string {
  if (typeof window === 'undefined') return 'http://localhost:3001';
  const loc = window.location;
  if (loc.protocol === 'https:') return loc.origin;
  if (loc.port === '5173' || loc.hostname === 'localhost' || loc.hostname === '127.0.0.1') {
    return `http://${loc.hostname}:3001`;
  }
  return loc.origin;
}

export const SERVER_URL = resolveServerUrl();

export interface UserStats {
  games: number;
  wins: number;
  losses: number;
  draws: number;
}

export interface UserInfo {
  id: string;
  username: string;
  nickname: string;
  createdAt: string;
  stats: UserStats;
}

export const TOKEN_KEY = 'go-platform-token';
